import React, { useState, useEffect } from "react";
import Header from "../layouts/Header";
import SlideBar from "../components/slide-bar/SlideBar";
import Card from "../components/card/Card";
import { useParams } from "react-router-dom";
import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY || "default-fallback-key";
const API_URL = process.env.REACT_APP_API_URL;
const API_FILE = process.env.REACT_APP_FILE_URL;

export default function DetailPage() {
    
    const [scrollIndex, setScrollIndex] = useState<number | null>(null);
    const [drawings, setDrawings] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    // let id = "";

    // if (id) {
    //     try {
    //         const bytes = CryptoJS.AES.decrypt(decodeURIComponent(id), secretKey);
    //         id = bytes.toString(CryptoJS.enc.Utf8);
    //     } catch (e) {
    //         console.error("Decrypt error:", e);
    //     }
    // }

    const fetchData = async () => {
        try {
            const res = await fetch(`${API_URL}/edit/${id}`, {
                method: "GET",
                credentials: "include",
            });
            if (!res.ok) throw new Error(`Error ${res.status}`);
            const result = await res.json();
            setDrawings(result.drawings);
        } catch (err) {
            console.error("API error:", err);
        } finally {
            setLoading(false);
        }
    };

    // Hàm reload để truyền xuống SlideBar / Card
    const reload = () => {
        setLoading(true);
        fetchData();
    };

    useEffect(() => {
        if (id) fetchData();
    }, [id]);

    return (
        <>
            <Header />
            <main className="main">
                <section className="sec-edit">
                    <div className="container">
                        <div className="sec-edit__content">
                            <SlideBar drawings={drawings} loading={loading} reload={reload} setScrollIndex={(val) => {
                                // console.log("ScrollIndex set from SlideBar:", val);
                                setScrollIndex(val);
                            }} />
                            <Card drawings={drawings} reload={reload} scrollIndex={scrollIndex} setScrollIndex={setScrollIndex} />
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}
